import React from 'react';
import css from './SectionSchoolHero.module.css';
import classNames from 'classnames';
import campaignImg1 from '../../../../assets/sport-img1.png';
import { Icons } from '../../../../components';
import Slider from 'react-slick';
import '../../../../styles/slick/slick.css';
import '../../../../styles/slick/slick-theme.css';

const sliderSettings = {
  dots: true,
  arrows: false,
  infinite: false,
  autoplay: true,
  autoplaySpeed: 2200,
  speed: 500,
  cssEase: 'ease',
  slidesToShow: 2,
  slidesToScroll: 1,
  variableWidth: false,
  focusOnSelect: false,
  centerMode: false,
  responsive: [
    {
      breakpoint: 1128,
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 580,
      settings: {
        slidesToShow: 1,
      },
    },
  ],
};

const TalentRoaster = ({ isMobileLayout }) => {
  return (
    <div className={classNames(css.postedContentSection, css.howItWorks)}>
      <div className={css.sectionHead}>
        <div className={css.leftSec}>
          <h2>Talent Roster</h2>
        </div>
      </div>
      <div className={css.sectionContent}>
        <div className={css.featuredListingsContent}>
          <div className={css.templatesSlider}>
            <Slider {...{ ...sliderSettings, arrows: !isMobileLayout }}>
              <div className={css.block}>
                <div className={css.blockUserInfo}>
                  <div className={css.blockUserImg}>
                    <img src={campaignImg1} alt="name" />
                  </div>
                  <div className={css.blockUserInfo}>
                    <div className={css.blockInfoLeft}>
                      <h3>Bill Catch</h3>
                      <p>Bill Catch is a standout wide receiver for Rutgers University.</p>
                    </div>
                  </div>
                </div>
                <div className={css.attachmentSec}>
                  <Icons name="attachment" />
                  <div className={css.attachmentInput}>
                    <span>
                      http://localhost:3000/l/mike-ball/66bb5206-bc82-407b-93af-712aadd982dc
                    </span>
                  </div>
                </div>
              </div>
              <div className={css.block}>
                <div className={css.blockUserInfo}>
                  <div className={css.blockUserImg}>
                    <img src={campaignImg1} alt="name" />
                  </div>
                  <div className={css.blockUserInfo}>
                    <div className={css.blockInfoLeft}>
                      <h3>Bill Catch</h3>
                      <p>Bill Catch is a standout wide receiver for Rutgers University.</p>
                    </div>
                  </div>
                </div>
                <div className={css.attachmentSec}>
                  <Icons name="attachment" />
                  <div className={css.attachmentInput}>
                    <span>
                      http://localhost:3000/l/mike-ball/66bb5206-bc82-407b-93af-712aadd982dc
                    </span>
                  </div>
                </div>
              </div>
              <div className={css.block}>
                <div className={css.blockUserInfo}>
                  <div className={css.blockUserImg}>
                    <img src={campaignImg1} alt="name" />
                  </div>
                  <div className={css.blockUserInfo}>
                    <div className={css.blockInfoLeft}>
                      <h3>Bill Catch</h3>
                      <p>Bill Catch is a standout wide receiver for Rutgers University.</p>
                    </div>
                  </div>
                </div>
                <div className={css.attachmentSec}>
                  <Icons name="attachment" />
                  <div className={css.attachmentInput}>
                    <span>
                      http://localhost:3000/l/mike-ball/66bb5206-bc82-407b-93af-712aadd982dc
                    </span>
                  </div>
                </div>
              </div>
            </Slider>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TalentRoaster;
